import { Order, Plant } from '@cemex-core/cmx-api';
import { Action } from '@ngrx/store';

export enum OneClickOwnFreightPlantsActionTypes {
  LOAD_OWNFREIGHT_PLANTS = '[One Click] Load ownfreight plants',
  LOAD_OWNFREIGHT_PLANTS_COMPLETE = '[One Click] Load ownfreight plants completed',
  SELECT_OWNFREIGHT_PLANT = '[One Click] Select ownfreight plants',
  RESET = '[One Click] Ownfreight plants reset',
}

export class OneClickLoadOwnFreightPlantsAction implements Action {
  readonly type = OneClickOwnFreightPlantsActionTypes.LOAD_OWNFREIGHT_PLANTS;

  constructor(public payload: Order) {}
}

export class OneClickLoadOwnFreightPlantsCompleteAction implements Action {
  readonly type = OneClickOwnFreightPlantsActionTypes.LOAD_OWNFREIGHT_PLANTS_COMPLETE;

  constructor(public payload: Plant[]) {}
}

export class OneClickSelectOwnFreightPlantAction implements Action {
  readonly type = OneClickOwnFreightPlantsActionTypes.SELECT_OWNFREIGHT_PLANT;

  constructor(public payload: Plant) {}
}

export class OneClickResetOwnFreightPlantsAction implements Action {
  readonly type = OneClickOwnFreightPlantsActionTypes.RESET;

  constructor() {}
}

export type OneClickOwnFreightPlantsActions =
  | OneClickLoadOwnFreightPlantsAction
  | OneClickLoadOwnFreightPlantsCompleteAction
  | OneClickSelectOwnFreightPlantAction
  | OneClickResetOwnFreightPlantsAction;
